/* eslint-disable no-plusplus */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect } from 'react';
import proptypes from 'prop-types';
const { func, bool: boolType, string: stringType, number: numberType, shape } = proptypes;
import { useDataModel } from '@thd-nucleus/data-sources';
import { useStore, ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import className from 'classnames';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { Online, Warning } from '@one-thd/sui-icons';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { ThemeProvider } from '@one-thd/sui-atomic-components';
import { getThemeByName } from '@thd-olt-component-react/stencil-themes';
import { useFetchPolicy, shouldIncludeThdDefaultLightTheme } from '../utils/recently-viewed';
import { isLoading, getAppId, getImpressionID } from '../utils/helpers';
import { ProductPodV7Carousel } from '../core/ProductPodV7Carousel';
import { rvDataModel } from '../dataModel';
import { FallbackCard } from '../core/FallbackCard';

const RecentlyViewed = (props) => {
  const {
    hideRating,
    hideTitle,
    schemaName,
    showLoading,
    slidesToShow,
    showFallback,
    entryId,
    hideCarouselArrows,
    hideComponentCallback,
    hidePrice,
    name,
    theme,
    enableRoundedProductImages,
    onTitleReady
  } = props;

  const { storeId, storeZip: zipCode, isLocalized } = useStore();
  const { channel, isConsumerApp } = useContext(ExperienceContext);

  const THDCustomer = useThdCustomer() || {};
  const userId = THDCustomer.svocID || THDCustomer.userID || THDCustomer.guestUserID;
  // TODO - THIS IS TEMP - This will change to 4 diff keys
  const pAPIKey = '2zSR74pj5Rq6zDtHENHkAScT4RWsl0pg';
  const isRVPriceEnabled = useConfigService('fs:isRVPriceEnabled');
  const chkRVPrice = !!((isRVPriceEnabled && !hidePrice));
  const shouldResetTheme = shouldIncludeThdDefaultLightTheme(theme);

  const opts = {
    variables: {
      storeId,
      key: pAPIKey,
      dataSource: 'rv_views',
      userId,
      unique: true,
      zipCode,
      apiName: 'views',
      appId: getAppId(channel, isConsumerApp),
      skipInstallServices: true,
      showPrice: true
    },
    persist: {
      storage: 'sessionStorage',
      expirationInSeconds: 5 * 60
    },
    skip: !isLocalized || !userId,
    ssr: false,
    // Force new request if we should not load from storage/cache
    fetchPolicy: 'network-only'
  };

  const { loading: recsLoading, data: recsData, error: recsError } = useDataModel('uds', opts);

  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined' && !recsLoading && recsData && !recsError) {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('RecentlyViewed.ready', { data: recsData?.uds });
    }
    if (!recsLoading && recsData?.uds?.metadata?.title && onTitleReady) {
      onTitleReady(recsData.uds.metadata.title);
    }
  }, [recsLoading]);

  const wrapperClasses = className(
    'sui-w-full', 'sui-pt-0', 'sui-pb-0',
    'sui-p-4', 'sui-bg-primary',
    schemaName
  );

  const fallbackInfo = {
    header: 'No Items Recently Viewed',
    subheader: 'Get Back to Shopping-check out our weekly ad for the latest sales',
    footerUrl: 'https://www.homedepot.com/c/localad',
    footer: 'Browse Weekly Ad'
  };

  if ((recsError || (recsData !== undefined && !recsData?.uds?.products?.length)) && !recsLoading) {
    if (hideComponentCallback) {
      hideComponentCallback();
    }
    if (showFallback) {
      return (
        <FallbackCard
          header="No Items Recently Viewed"
          subheader="Get back to shopping—check out our weekly ad for the latest sales"
          footerUrl="https://www.homedepot.com/c/localad"
          footer="Browse Weekly Ad"
          icon={Online}
          componentName="RecentlyViewed"
        />
      );
    }
    return null;
  }

  if (!isLocalized || !userId) {

    if (channel === 'mobile') {
      return (
        <FallbackCard
          header="We're having trouble loading your recently viewed items."
          subheader="Get back to shopping—check out our weekly ad for the latest sales"
          footerUrl="https://www.homedepot.com/c/localad"
          footer="Browse Weekly Ad"
          icon={Warning}
          componentName="RecentlyViewed"
        />
      );
    }

    return null;
  }

  return (
    <ImpressionProvider
      data={{
        id: getImpressionID(entryId),
        component: RecentlyViewed.displayName,
        name: RecentlyViewed.displayName,
        type: 'product',
        recType: 'views',
        position: '',
        category: '',
        categoryPosition: '',
        ...(name ? { sectionSlotID: name } : {}),
      }}
    >
      <ThemeProvider theme={getThemeByName(theme)}>
        <div id={schemaName} className={wrapperClasses} data-type="container" data-component="RecentlyViewed">
          <meta data-prop="name" content={schemaName} />
          <ProductPodV7Carousel
            storeId={storeId}
            zipCode={zipCode}
            scheme={schemaName}
            showLoading={showLoading}
            parent="recently-viewed"
            hideRating={hideRating}
            hideFavorites
            hideATC={!chkRVPrice}
            hidePrice={!chkRVPrice}
            hideTitle={hideTitle}
            data={recsData?.uds}
            loading={isLoading(recsData, recsLoading)}
            slidesToShow={slidesToShow}
            showFallback={showFallback}
            fallbackInfo={fallbackInfo}
            userId={userId}
            hideCarouselArrows={hideCarouselArrows}
            theme={theme}
            shouldResetTheme={shouldResetTheme}
            enableRoundedProductImages={enableRoundedProductImages}
            telemetryKey={RecentlyViewed.displayName}
          />
        </div>
      </ThemeProvider>
    </ImpressionProvider>
  );
};

RecentlyViewed.dataModel = rvDataModel;

RecentlyViewed.displayName = 'RecentlyViewed';

RecentlyViewed.propTypes = {
  hideRating: boolType,
  showLoading: boolType,
  schemaName: stringType.isRequired,
  hideTitle: boolType,
  slidesToShow: shape({
    sm: numberType,
    md: numberType,
    lg: numberType
  }),
  showFallback: boolType,
  entryId: stringType,
  hideCarouselArrows: boolType,
  hideComponentCallback: func,
  hidePrice: boolType,
  name: stringType,
  theme: stringType,
  enableRoundedProductImages: boolType,
  onTitleReady: func
};

RecentlyViewed.defaultProps = {
  hideRating: false,
  showLoading: true,
  hideTitle: false,
  slidesToShow: null,
  showFallback: false,
  entryId: null,
  hideCarouselArrows: false,
  hideComponentCallback: () => { },
  hidePrice: false,
  name: '',
  theme: null,
  enableRoundedProductImages: false,
  onTitleReady: undefined
};

export default RecentlyViewed;